<template>
  <div v-if="polls.length" class="stat-list">
    <div
      v-for="(poll, idx) in polls"
      :key="poll.pollId || idx"
      class="poll-card"
    >
      <p class="poll-question">
        {{ poll.question || 'Poll ' + (idx + 1) }}
      </p>
      <div v-for="ans in answers(poll)" :key="ans.id" class="poll-answer-row">
        <span class="poll-answer-label" :title="ans.key">{{ ans.key }}</span>
        <div class="poll-answer-track">
          <div
            class="poll-answer-fill"
            :style="{ width: pct(poll, ans) + '%' }"
          ></div>
        </div>
        <span class="poll-answer-count">{{ ans.numVotes || 0 }}</span>
      </div>
      <div class="poll-footer">
        {{ totalVotes(poll) }} vote{{ totalVotes(poll) !== 1 ? 's' : '' }}
        <template v-if="poll.numRespondents">
          · {{ poll.numRespondents }} respondent{{
            poll.numRespondents !== 1 ? 's' : ''
          }}
        </template>
      </div>
    </div>
  </div>
  <div v-else class="empty-state">
    <svg
      width="40"
      height="40"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="1.4"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <circle cx="12" cy="12" r="10" />
      <line x1="12" y1="8" x2="12" y2="12" />
      <line x1="12" y1="16" x2="12.01" y2="16" />
    </svg>
    <p>No polls were run in this session.</p>
  </div>
</template>

<script>
export default {
  name: 'PollsTab',
  props: {
    polls: { type: Array, default: () => [] },
  },
  methods: {
    answers(poll) {
      if (!poll || !poll.answers) return [];
      return Object.values(poll.answers);
    },
    totalVotes(poll) {
      return this.answers(poll).reduce((acc, a) => acc + (a.numVotes || 0), 0);
    },
    pct(poll, ans) {
      const total = this.totalVotes(poll);
      if (!total) return 0;
      return Math.round(((ans.numVotes || 0) / total) * 100);
    },
  },
};
</script>
